import Quill from "quill";

const getEditorLength = (quillInstance: Quill) => {
  // Quill always includes a trailing newline, even when the editor is empty.
  return Math.max(0, quillInstance.getLength() - 1);
};

export const getEditorContent = (quillInstance: Quill) => {
  const content = quillInstance.root.innerHTML;

  return content === "<p><br></p>" ? "" : content;
};

export const enforceMaxLength = (quillInstance: Quill, maxLength?: number) => {
  const currentLength = getEditorLength(quillInstance);
  const wasTrimmed = !!maxLength && currentLength > maxLength;

  if (wasTrimmed) {
    quillInstance.deleteText(maxLength, currentLength - maxLength, "silent");
  }

  return {
    charCount: getEditorLength(quillInstance),
    wasTrimmed,
  };
};

export const setQuillRef = (
  ref: React.Ref<Quill> | undefined,
  value: Quill | null
) => {
  if (typeof ref === "function") {
    ref(value);
  } else if (ref) {
    (ref as React.MutableRefObject<Quill | null>).current = value;
  }
};
